import TGASDK from '@/config/TGASDK'
import { getClient } from '@/helper'
import { getLocalLang } from '@/i18n'
import { useLocation, useMatch } from 'react-router-dom'

const useRuntime = (): Runtime => {
  const match = useMatch('/:channel/*')
  const language = getLocalLang()

  const { search } = useLocation()
  const params = match?.params

  return {
    lang: language,
    channel: params?.channel || TGASDK.DEFAULT_APP_CODE,
    client: getClient(),
    path: params ? params['*'] || '' : '',
    query: new URLSearchParams(search),
    search
  }
}

interface Runtime {
  lang: string
  channel: string
  client: 'mobile' | 'pc'
  path: string
  query: URLSearchParams
  search: string
}

export default useRuntime
